// extracted by mini-css-extract-plugin
export var dividerContainer = "_86-0";
export var line = "_86-1";